import { ReactNode } from "react";

export class Menu {
  id: string;

  name: string | JSX.Element;

  target: string;

  link: string;

  href: string;

  icon: ReactNode;

  parentId: string;

  parentIds: Array<string>;

  messagekey: string;

  children: Array<Menu>;

  menuExtInfo: { popText?: string };

  /**
   * 子标题，展示在标题下面
   */
  subTitle?: string;

  static find(menus: Array<Menu>, predicate: (menu: Menu) => boolean): Menu {
    if (!Array.isArray(menus)) return undefined;
    for (let index = 0; index < menus.length; index += 1) {
      const menu = menus[index];
      if (predicate(menu)) {
        return menu;
      }
      const child = this.find(menu.children, predicate);
      if (child) return child;
    }
    return undefined;
  }
}
